module.exports = __webpack_public_path__ + "img/video_btn.6a72052e.png";